import Login from './components/login/Login.vue';
import Welcome from './components/welcome/Welcome.vue';
import Home from './components/home/Home.vue';
import Guide from './components/users/Guide.vue';
import ChangePassword from './components/change-password/ChangePassword.vue';
import GuideManual from './components/guide-manual/GuideManual.vue';
import GuideManualAcceptance from './components/guide-manual-acceptance/GuideManualAcceptance.vue';
import ServiceOrders from './components/os/ServiceOrders.vue';
import ServiceOrderMap from './components/os/ServiceOrderMap.vue';
import { checkAuthentication, checkAuthenticationAndMandatoryActions, checkNotAuthentication } from './auth-token';


export const homeChildrenPath = [
	{ path: "/guide/me", name: "guide", component: Guide, props: true, beforeEnter: checkAuthentication },
  { path: "/manual-do-guia", name: "guide-manual", menu: true, label: 'Manual', component: GuideManual, beforeEnter: checkAuthentication },
  { path: "/ordens", name: "os-ordem", menu: true, label: 'Ordens', component: ServiceOrders, beforeEnter: checkAuthenticationAndMandatoryActions },
  { path: "/mapa", name: "os-map", menu: true, label: 'Mapa', component: ServiceOrderMap, beforeEnter: checkAuthenticationAndMandatoryActions },
];

export const routes = [
  { path: "/login", name: "login", component: Login, beforeEnter: checkNotAuthentication },
  { path: "/welcome", name: "welcome", component: Welcome, beforeEnter: checkAuthenticationAndMandatoryActions },
  { path: "/aceitacao-do-manual-do-guia", name: "guide-manual-acceptance", component: GuideManualAcceptance, beforeEnter: checkAuthentication },
  { path: "/change-password", name: "changePassword", component: ChangePassword },
  { path: "", name: "home", component: Home, beforeEnter: checkAuthentication, children: homeChildrenPath },
  { path: "*", component: Home, beforeEnter: checkAuthenticationAndMandatoryActions }
];



// WEBPACK FOOTER //
// ./src/routes.js